import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/Button';
import { useRegion } from '../../context/RegionContext';
import styles from './Hero.module.css';

export const Hero: React.FC = () => {
  const { t } = useLanguage();
  const { region } = useRegion();
  const navigate = useNavigate();

  const heroContent = {
    ...t.hero,
    ...(region === 'GCC' && t.hero.gcc ? t.hero.gcc : {}),
  };

  return (
    <section className={styles.hero}>
      <div className={styles.hero__container}>
        <div className={styles.hero__layout}>
          <div className={styles.hero__text}>
            <div className={styles.hero__badge}>
              <Sparkles size={14} />
              {heroContent.badge}
            </div>

            <h1 className={styles.hero__title} id="hero-title">
              {heroContent.title}
              <br />
              <span className={styles.hero__titleHighlight}>
                {heroContent.titleHighlight}
              </span>
            </h1>

            <p className={styles.hero__subtitle}>{heroContent.subtitle}</p>

            <div className={styles.hero__ctas}>
              <Button
                variant="primary"
                size="lg"
                icon={<ArrowRight size={20} />}
                onClick={() => navigate('/assessment')}
              >
                {t.hero.cta1}
              </Button>
              <a
                href="#process"
                className={styles.hero__textLink}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {t.hero.cta2} →
              </a>
            </div>

            <div className={styles.hero__proof}>
              {(t.proof.stats || []).slice(0, 3).map((stat, idx) => (
                <div key={idx} className={styles.hero__proofItem}>
                  <div className={styles.hero__proofValue}>{stat.value}</div>
                  <div className={styles.hero__proofLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.hero__media}>
            <picture>
              <source
                type="image/webp"
                srcSet="/images/hero_digital_excellence-800.webp 800w, /images/hero_digital_excellence-1600.webp 1600w"
                sizes="(max-width: 900px) 100vw, 520px"
              />
              <img
                className={styles.hero__image}
                src="/images/hero_digital_excellence.png"
                alt="Modern enterprise office representing digital excellence"
                loading="eager"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
